<template>
  <div class="list-page">
    <crumbs title="专利服务合作咨询" />
    <div class="list-page__querybar">
      <el-row>
        <el-col :span="12">
          <el-date-picker
            v-model="queryCondition.publishDate"
            type="daterange"
            :unlink-panels="true"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="10">
          <el-input
            v-model="queryCondition.keyWord"
            clearable
            placeholder="公司名称/联系人"
          >
          </el-input>
        </el-col>
        <el-col class="fn-text-right" :span="2">
          <el-button
            @click="handleSearch"
            size="medium"
            type="success"
            icon="el-icon-search"
            round
            >查询</el-button
          >
        </el-col>
      </el-row>
    </div>
    <div class="list-page__toolbar">
      <download
        url="/api/servicedocking/exportservicedocking"
        :params="{ idList: multipleSelection.map((item) => item.id) }"
        fileName="专利服务合作咨询"
        >导出选中</download
      >
      <download
        url="/api/servicedocking/exportservicedocking"
        :params="paramsExportAll"
        buttonType="success"
        fileName="专利服务合作咨询"
        >导出当前条件下全部</download
      >
      <el-button type="warning" icon="el-icon-delete" @click="handleBatchDelete"
        >删除</el-button
      >
    </div>
    <div
      class="list-page__table"
      v-loading="isLoading"
      element-loading-text="拼命加载中"
    >
      <el-table
        :data="queryList"
        @selection-change="handleSelectionChange"
        border
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column type="selection" width="40"> </el-table-column>
        <el-table-column
          prop="companyName"
          label="公司名称"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="contact"
          label="联系人"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="phoneNumber"
          label="联系电话"
          width="110"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="post"
          label="职务"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="typeName"
          label="服务类型"
          width="110"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="email"
          label="邮箱"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="提交时间" width="90" align="center">
          <template slot-scope="scope">
            <p>
              {{ scope.row.createTime.trim().split(/\s+/)[0] }}
            </p>
            <!-- <p>
                {{ scope.row.createTime.trim().split(/\s+/)[1] }}
              </p> -->
          </template>
        </el-table-column>
      </el-table>
      <div class="fn-text-center mt-20">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :hide-on-single-page="true"
          :total="total"
          :page-size="queryCondition.pageSize"
          :current-page.sync="queryCondition.pageIndex"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "patentServiceList",
  data() {
    return {
      //查询条件
      queryCondition: {
        publishDate: [],
        keyWord: "",
        pageIndex: 1,
        pageSize: 15
      },
      total: 0,
      //是否处于loading状态
      isLoading: true,
      //查询结果
      queryList: [],
      //表格当前的选项（多选）
      multipleSelection: []
    };
  },
  computed: {
    paramsExportAll() {
      let { keyWord, publishDate } = this.queryCondition;
      let [createBegin = "", createEnd = ""] = publishDate || [];
      return {
        keyWord,
        createBegin,
        createEnd
      };
    }
  },
  created() {
    this.loadList();
  },
  methods: {
    //出来参数
    processParams() {
      let { keyWord, pageIndex, pageSize, publishDate } = this.queryCondition,
        mixin = {},
        [createBegin = "", createEnd = ""] = publishDate || [];
      Object.keys(mixin).map((item) => {
        mixin[item] =
          this.queryCondition[item] === "" ? -1 : this.queryCondition[item];
      });
      return {
        keyWord,
        pageIndex,
        pageSize,
        ...mixin,
        createBegin,
        createEnd
      };
    },
    //获取列表
    loadList() {
      //初始化
      // this.queryList = [];
      this.isLoading = true;
      this.$api("service", "getPatentList", this.processParams()).then(
        (res) => {
          this.isLoading = false;
          this.total = res.count;
          this.queryList = res.serviceDockingModelModels;
        }
      );
    },
    //点击后查询
    handleSearch() {
      this.queryCondition.pageIndex = 1;
      this.loadList();
    },
    //表格相关
    //点击选中/取消选中表格选择项
    handleSelectionChange(selection) {
      this.multipleSelection = selection;
    },
    // //点击编辑
    // handleLook(row) {
    //   const { id } = row;
    //   this.redirectByPath(
    //     `/admin/policyManage/projectMessageInfo/modification`,
    //     {
    //       id
    //     }
    //   );
    // },
    //删除
    //点击批量删除
    handleBatchDelete() {
      const idList = this.multipleSelection.map((item) => item.id);
      if (idList.length) {
        this.$confirm("此操作将批量删除所选中的数据, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.loadDeleteData(idList);
          })
          .catch(() => {});
      }
    },
    //点击一条删除
    handleDelete(row) {
      this.$confirm("此操作将删除当前所选中的数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.loadDeleteData([row.id]);
        })
        .catch(() => {});
    },
    loadDeleteData(idList) {
      this.$api("service", "batchDeletePatent", idList).then((res) => {
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.loadList();
        }
      });
    },
    //点击切换分页触发
    handleCurrentChange() {
      this.loadList();
    }
  }
};
</script>

<style></style>
